export enum StudyMode {
  Normal = "Normal",
  Independent = "Independent",
}
